import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/guatrend";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "bg-background-50/95 shadow-soft backdrop-blur"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="relative flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-seedling-line text-lg"></i>
            <span className="absolute -right-0.5 -top-0.5 flex h-3 w-3 items-center justify-center rounded-full bg-accent-500">
              <i className="ri-heart-fill text-[7px] text-background-50"></i>
            </span>
          </span>
          <span
            className={`font-display text-xl md:text-2xl ${
              scrolled || open ? "text-foreground-900" : "text-background-50"
            }`}
          >
            吃瓜精选
          </span>
        </a>

        <div
          className={`hidden items-center gap-7 lg:flex ${
            scrolled ? "text-foreground-700" : "text-background-50/90"
          }`}
        >
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-medium transition-colors hover:text-primary-600 whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#submit"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 sm:inline-flex"
          >
            <i className="ri-edit-2-line"></i>
            推荐好瓜
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`inline-flex h-10 w-10 items-center justify-center rounded-full lg:hidden ${
              scrolled ? "bg-background-100 text-foreground-800" : "bg-background-50/20 text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-6 pt-2 lg:hidden">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block border-b border-background-100 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#submit"
            onClick={() => setOpen(false)}
            className="mt-4 flex items-center justify-center whitespace-nowrap rounded-full bg-accent-500 px-4 py-2.5 text-sm font-medium text-background-50"
          >
            推荐好瓜
          </a>
        </div>
      )}
    </header>
  );
}